import HeroBasic from '../components/HeroBasic'
import Card from '../components/Card'
import InfoBox from '../components/InfoBox'

function Contact() {
    const heroTitle = "Contact Us"
    const heroSubtitle = "Questions, comments, or partnership inquiries."

    const cardHeader = "Get Involved"

    return (
        <div>
            <HeroBasic title={heroTitle} subtitle={heroSubtitle} />

            <Card header={cardHeader}>
                <p>
                    If you have questions about the data or would like to become
                    involved in the project, please contact the project team.
                </p>

                <InfoBox>
                    <p>
                        <strong>Email:</strong>{" "}
                        <a href="mailto:info@peer.org">
                            info@peer.org
                        </a>
                    </p>
                </InfoBox>

                <h3 className="mt-4">Report a Data Issue</h3>

                <p>
                    We strive to provide accurate and well-organized environmental
                    enforcement records. However, errors can occasionally occur
                    during document processing or classification.
                </p>

                <p>
                    If you identify a document that appears to be incorrectly
                    classified, contains multiple documents combined into one file,
                    or has another issue, please email us with:
                </p>

                <ul>
                    <li>The file name or a link to the document</li>
                    <li>A brief description of the issue</li>
                    <li>A screenshot of the page, if applicable</li>
                </ul>

                <p>
                    Our team will review the report and make corrections to the
                    database when appropriate. Your feedback helps improve the
                    accuracy and quality of this resource for everyone.
                </p>
            </Card>
        </div>
    )
}

export default Contact